module.exports = "<p>\n    <b>Acoso.online</b><br>\n    <a href=\"http://acoso.online/\">http://acoso.online/</a><br>\n    Repositorio de recomendaciones legales\n</p>\n<p>\n    <b>#ColegiosLibresDeAcoso</b><br>\n    <a href=\"https://www.instagram.com/colegioslibresdeacoso/\">https://www.instagram.com/colegioslibresdeacoso/</a><br>\n    Apoyo y acompañamiento legal\n</p>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/resultado/accordion-html/accordion-plataformas.html
// module id = 623
// module chunks = 0